<template>
    <div>
        <!-- 搜索框 -->
        <a-card size="small" title="推送记录">
        </a-card>

        <channelSelecter :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>

        <a-card size="small">
            <searchE ref="messageSearchId" @handleSearch="handleSubmit"></searchE>
            <tableE ref="messageTableID"  :style="{width:tableWidth}"></tableE>
        </a-card>

         
    </div>
</template>
<script>
import searchE from './search'
import tableE from './table'

import channelSelecter from '../../components/channelSelecter'

export default {
    data() {
        return {
            searchP:{},
            tableWidth:'800px',
            channelcode:''
        };
    },
    methods: {
        handleChannelChange(item){
            this.channelcode = item.value;
            this.searchP.channelcode = item.value;
            this.$refs.messageSearchId.handleSubmit(this.searchP);
        },
        handleSubmit(searchP){
            searchP.channelcode = this.channelcode;
            this.$refs.messageTableID.handleSearch(searchP);
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    components:{
        searchE,
        tableE,
        channelSelecter
    },
    mounted(){
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);

    },
};
</script>
<style scoped>

</style>
